export default () => ({
  companies: {},
  searchResult: {},
  selectedCompanyId: 0,
  searchedCompany: null
})
